import React, { createContext, useCallback, useContext, useState } from 'react';

type PartyDetailsUrlContextType = {
  partyDetailsUrl: string;
  setPartyDetailsUrl: (url?: string) => void;
};

export const defaultPartyDetailsUrl = '/om-partiet';

const PartyDetailsUrlContext = createContext<
  PartyDetailsUrlContextType | undefined
>(undefined);

export function PartyDetailsUrlProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [partyDetailsUrl, setPartyDetailsUrlState] = useState(
    defaultPartyDetailsUrl,
  );

  const setPartyDetailsUrl = useCallback((url?: string) => {
    if (!url) return;
    setPartyDetailsUrlState(url);
  }, []);

  return (
    <PartyDetailsUrlContext.Provider
      value={{ partyDetailsUrl, setPartyDetailsUrl }}
    >
      {children}
    </PartyDetailsUrlContext.Provider>
  );
}

export function usePartyDetailsUrl() {
  const context = useContext(PartyDetailsUrlContext);
  return (
    context || {
      partyDetailsUrl: defaultPartyDetailsUrl,
      setPartyDetailsUrl: () => undefined,
    }
  );
}
